import React from 'react';
import PropTypes from 'prop-types';
import DoneIcon from '../../GoogleIcons/Outlined/DoneIcon';
import MeetingRoom from '../../GoogleIcons/Outlined/MeetingRoom';
import Button from '../Button/Button';
import { NOOP } from '../../../utils/const';
import NavDropdown from '../../NavDropdown';

const MenuUfficiItems = ({
  uffici, ufficioSelezionato, onUfficioChange,
}) => (
  uffici.map((ufficio) => (
    <NavDropdown.Item key={ufficio} onClick={ufficio !== ufficioSelezionato ? () => onUfficioChange(ufficio) : NOOP}>
      <Button>
        <MeetingRoom /> Ufficio {ufficio}
        {ufficioSelezionato === ufficio && <DoneIcon />}
      </Button>
    </NavDropdown.Item>
  ))
);

MenuUfficiItems.propTypes = {
  uffici: PropTypes.arrayOf(PropTypes.string),
  ufficioSelezionato: PropTypes.string,
  onUfficioChange: PropTypes.func.isRequired,
};

MenuUfficiItems.defaultProps = {
  uffici: [],
  ufficioSelezionato: null,
};

export default MenuUfficiItems;
